import React from 'react';
import { styled } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ACCENT_BLUE } from './qcTheme';

// Sticky at the scrollport bottom (prototype); `bottom` compensates the Layout's 24px padding since sticky offsets resolve against the content box.
const FooterBar = styled('div')({
  position: 'sticky',
  bottom: '-24px',
  zIndex: 6,
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
  borderTop: '1px solid rgba(0,0,0,0.08)',
  background: '#fff',
  borderRadius: '0 0 4px 4px',
  boxShadow: '0 -2px 6px rgba(0,0,0,0.06)',
});

const PagerLink = styled('button', {
  shouldForwardProp: prop => prop !== 'on',
})<{ on: boolean }>(({ on }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  border: 'none',
  background: 'none',
  padding: 0,
  fontFamily: 'inherit',
  fontSize: '0.8125rem',
  fontWeight: 500,
  letterSpacing: '0.46px',
  textTransform: 'uppercase',
  color: on ? ACCENT_BLUE : 'rgba(0,0,0,0.38)',
  cursor: on ? 'pointer' : 'default',
  userSelect: 'none',
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
  },
}));

export interface QuestionPagerFooterProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export default function QuestionPagerFooter({ hasPrevious, hasNext, onPrevious, onNext }: QuestionPagerFooterProps): JSX.Element {
  return (
    <FooterBar>
      <PagerLink type='button' on={hasPrevious} disabled={!hasPrevious} onClick={onPrevious}>
        <ChevronLeftIcon />
        Previous Question
      </PagerLink>
      <PagerLink type='button' on={hasNext} disabled={!hasNext} onClick={onNext}>
        Next Question
        <ChevronRightIcon />
      </PagerLink>
    </FooterBar>
  );
}
